module.exports = __webpack_public_path__ + "img/quest_icon_0010_inventory.85655780.png";